import { practicalStep } from "../runTour"
import type { TutorialPart } from "./types"

/**
 * Onboarding part 2: create an institution (seedbed client). Same
 * hand-off pattern as createStudentPart — ends on the real click into
 * InstitutionFormPage.
 */
export const createInstitutionPart: TutorialPart = {
  id: "create-institution",
  title: "Crear una organización",
  requiredPolicies: ["academy:institutions:edit"],
  route: "/programs/institutions",
  waitForSelector: '[data-tour="module-create"]',
  steps: [
    {
      popover: {
        title: "Parte 2: crear una organización",
        description:
          "Este es el listado de organizaciones. Crear una nueva solo pide el nombre — el resto de los datos son opcionales y se pueden completar después.",
      },
    },
    practicalStep({
      element: '[data-tour="module-create"]',
      popover: {
        title: "👉 Hazlo tú: crea una organización",
        description: 'Haz clic en "+ Nueva organización" para abrir el formulario real. Con el nombre ya puedes guardar.',
        side: "bottom",
      },
    }),
  ],
}
